
var readMe_user = " 批量新增模板说明：\n" +
  "     提示：\n" +
  "        单次新增最多50条，若其中有一条错误，则本次导入视为失败，请重新导入。\n" +
  "\n" +
  "  1、 account|账号 (必填)\n" +
  "\n" +
  "      说明：用户账号\n" +
  "      必填：必填\n" +
  "      规则： 账号格式为 6-16个字符 ，只能使用中文、英文、数字、下划线等字符。\n" +
  "\n" +
  "  2、 name|姓名 (必填)\n" +
  "\n" +
  "      说明：账号昵称\n" +
  "      必填：必填\n" +
  "      规则： 账号格式为 2-10个字符 ，只能使用中文、英文、数字、下划线等字符。。\n" +
  "\n" +
  "  3、 password|密码 (必填)\n" +
  "\n" +
  "      说明：账号密码\n" +
  "      必填：必填\n" +
  "      规则： 账号格式为 6-15个字符 。\n" +
  "\n" +
  "  4、 groupIdTemp|群组id （选填）\n" +
  "      说明： 账号的初始群组ID（群组管理中能看到群组的ID），只能添加本企业拥有的群组，群组之间使用 :  隔开\n" +
  "      必填： 选填\n" +
  "      示例：  278:277:274\n" +
  "\n" +
  "  5、 identityCard|身份证 (选填)\n" +
  "\n" +
  "      说明：用户身份证号\n" +
  "      必填：选填\n" +
  "      规则： 身份证格式。\n" +
  "\n" +
  "  6、 funcs|功能 (选填)\n" +
  "\n" +
  "      说明：账号初始的功能 ，功能(1=单呼,2= 定位,3=好友,4= 录音,5 =创建群组 , 6 =群呼) 功能之间使用“,” 隔开\n" +
  "      必填：选填\n" +
  "      示例： 全部功能 =  1,2,3,4,5,6\n" +
  "\n" +
  "  7、 voicePrio|权限 (选填)\n" +
  "\n" +
  "      说明：账号对讲等级 ，用户对讲等级(0=低,1= 中,2 =高,3= 特高) ，账号对讲等级 默认为 低\n" +
  "      必填：选填\n" +
  "      示例：3\n" +
  "\n" +
  "  8、 phone|电话 (选填)\n" +
  "\n" +
  "      说明： 账号电话\n" +
  "      必填：选填\n" +
  "      规则： 手机号码格式。\n" +
  "\n" +
  "  9、 qb|Q币 (选填)\n" +
  "\n" +
  "      说明： 账号划分Q币\n" +
  "      必填：选填\n" +
  "      规则： 只能输入数字,且小于4，Q币和订单只能选一个,Q币以第一个用户的数量为准\n" +
  "\n" +
  "  10、 orderId|订单号 (选填)\n" +
  "\n" +
  "      说明： 用户设置订单号，可以来调度，定位等\n" +
  "      必填：选填\n" +
  "      规则： 只能输入数字,和Q币只能选一个,订单后只能有一个\n" +
  "\n"



const file = {
  confirm: {
    message: {
      confirmByExportExcel: "确定要导出Excel?"
    }
  },
  export: {
    excel: {
      /**
       * 导出 代理表相关字段配置
       *  title与head是一一对应的
       */
      transaction:{
        fileName: "交易明细",
        //title与head是一一对应的
        title: ["订单号", "操作人账号", " 操作类型 ", "交易金额", "来源人账号 ",  "来源人操作前余额", "来源人操作后余额", "目标人账号", "目标人操作前余额", "目标人操作后余额", "创建时间"],
        head: ["orderId", "operatorAccount", "type", "value", "originAccount", "originBeforeBalance", "originAfterBalance", "targetAccount", "targetBeforeBalance",  "targetAfterBalance",  "createDate"]
      },
      proxyTable: {
        fileName: "代理信息",
        title: ["代理账号", "代理名称","企业数量", "注册用户", "使用用户", "终身用户"  , "余额", "创建时间", "修改时间"],
        head: ["account", "name","enterpriseCount", "terminalCount", "useTerminalCount", "lifelongCount","balance", "createDate", "modifyDate"]
      },
      enterpiseTable: {
        fileName: "企业信息",
        title: ["企业账号", "企业名称", "注册用户", "使用用户", "终身用户"  ,"余额", "创建时间", "修改时间"],
        head: ["account", "name", "terminalCount", "useTerminalCount", "lifelongCount","balance", "createDate", "modifyDate"]
      },
      terminalTable: {
        fileName: "企业用户信息表",
        title: ["账号", "姓名", "电话", "功能", "对话等级","启用时间","到期时间"],
        head: ["account", "name", "phone", "funcs", "voicePrio","enableTime","maturityTime"]
      },
      terminalTable2nd: {
        fileName: "企业用户信息表",
        title: ["账号", "姓名", "电话", "功能", "对话等级","启用时间","到期时间","imei","机型"],
        head: ["account", "name", "phone", "funcs", "level","enableTime","expiredTime","imei","modelName"]
      },
      imeiTable: {
        fileName: "imei批次信息表",
        title: ["IMEI号(必填)","账号(必填)", "机器型号(必填)","机器型号id","批次号","创建时间","修改时间","用户id", "企业id","企业账号","企业名称",
                "代理账号","代理名称","子代账号","子代名称","用户名称","密码","群组","用户对讲等级","用户功能","手机号","身份证","备注","ICCID"],
        head: ["imei","account","modelName","modelId","batch","createDate","modifyDate","userId", "entId","entAccount","entName",
          "proxyAccount","proxyName","subAccount","subName","","","","","","","","",""]
      },
      checkinIccid:{
        fileName: "接入iccidi数据导出",
        title: ["账号","姓名","终端id","企业账号","企业名称","代理名称","订单id","imei1", "imei2","iccid1","iccid2",
          "QB到期时间","订单激活时间","订单开始时间","订单结束时间"],
        head: ["account","name","terminalId","entAccount","entName","proxyName","orderId","imei_1", "imei_2","iccid_1","iccie_2",
          "qbExpireDate","activeTime","enableTime","maturityTime"]
      },
      patrolCount:{
        fileName: "巡更时间统计数据导出",
        title: ["计划名称","计划总数","上报总数","上报有效数","上报无效数","上报有效率","上报无效率"],
        head: ["planName","planCount","planCount1","validTaskCount","notValidTaskCount","planCount3","planCount4"]
      },
      groupUser: {
        fileName: "群组用户信息表",
        title: ["群组名称","账号", "姓名", "电话", "功能", "对话等级","启用时间","到期时间"],
        head: ["curGroupName","account", "name", "phone", "funcs", "level","enableTime","maturityTime"]
      },
    }
  },
  import: {
    template: {
      user: {
        zipName:'批量新增用户模板',
        fileName:'用户信息表',
        title: ["用户账户(必填)", "用户姓名(必填)", "用户密码(必填)", "群组", "身份证", "用户功能", "用户对讲等级", "手机号","备注","ICCID","Q币划分","订单绑定(订单号)","具体表格项查看第二页说明书"],
        header: ["account", "name", "password", "groupIdTemp", "identityCard", "funcs", "voicePrio", "phone", "remark","iccid","qb","orderId"],
        readMe:{
          fileName:'批量新增模板说明.txt',
          content:readMe_user
        },
      }
    }
  },



  importLifeFree: {
    template: {
      user: {
        zipName:'批量新增IMEI',
        fileName:'IMEI信息表',
        title: ["IMEI号(必填)","机器型号(必填)","账号起始数据","备注"],
        header: ["IMEI","model","startAccount","remark"],
        //IMEI号(必填)	机器型号(必填)	账号(必填)	机器型号id	批次号	创建时间	修改时间	用户id	企业id
        title_ent: ["IMEI号(必填)","账号(必填)","用户名称","密码","群组","用户对讲等级","用户功能","手机号","身份证","备注","ICCID"],
        header_ent: ["imei","account","userName","password","groupIds","talkLevel","func","phone","idcard","remark","iccid"],
     /*   readMe:{
          fileName:'批量新增IMEI说明.txt',
          content:readMe_user
        },*/
      }
    }
  },

  iccidImport: {
    template: {
      user: {
        zipName:'批量新增iccid模板',
        fileName:'iccid信息表',
        title: ["iccid卡号(必填)"],
        header: ["iccid"],
        readMe:{
          fileName:'批量新增模板说明.txt',
          content:readMe_user
        },
      }
    }
  },

  //专网导入
  privateImport:{
      template:{
        zipName:'',
        fileName:'专网信息表',
        title: ["专网企业(必填)","专网id(必填)"],
        header: ["eid","tid"],
        readMe:{
          fileName:'批量新增模板说明.txt',
          content:readMe_user
        },
      }
  },

  track808:{
    template:{
      zipName:'',
      fileName:'808信息表',
      title: ["808协议设备id(必填)","ip(必填)","端口号(必填)"],
      header: ["agreementId","ip","port"],
      readMe:{
        fileName:'批量新增模板说明.txt',
        content:readMe_user
      },
    }
  },

  entTrack808:{
    template:{
      zipName:'',
      fileName:'808企业信息表',
      title: ['808协议设备id(必填)','企业id(必填)', 'gps终端型号', '制造商id','车牌号', '车牌颜色'],
      header: ["agreementId","enterpriseId","terminalType","manufacturerId","licencePlate","licencePlateColour"],
      readMe:{
        fileName:'批量新增模板说明.txt',
        content:readMe_user
      },
    }
  },

  //企业专网导入
  entPrivateImport:{
    template:{
      zipName:'',
      fileName:'专网信息表',
      title: ["专网企业(必填)","专网id(必填)","企业id(必填)"],
      header: ["eid","tid","enterpriseId"],
      readMe:{
        fileName:'批量新增模板说明.txt',
        content:readMe_user
      },
    }
  },



};




export default file;



// WEBPACK FOOTER //
// ./src/api/lang/modules/file/file_zh.js